var _defs, _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c278ae72d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c83a2dcfe7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 14 L 29 14 L 29 29.03125 L 1 29.03125 Z M 1 14 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c278ae72d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c83a2dcfe7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f55d0b",
    d: "M 15 19.050781 C 14.703125 19.050781 14.410156 19.039062 14.121094 19.011719 C 12.625 18.878906 11.179688 18.410156 9.890625 17.640625 C 8.601562 16.871094 7.503906 15.820312 6.675781 14.570312 L 1.617188 23.589844 L 8.140625 23.589844 L 11.425781 29.03125 L 16.109375 18.992188 C 15.738281 19.03125 15.371094 19.050781 15 19.050781 Z M 23.335938 14.558594 C 22.136719 16.371094 20.382812 17.746094 18.335938 18.476562 L 16.003906 23.558594 L 18.574219 29.03125 L 21.859375 23.589844 L 28.382812 23.589844 Z M 23.335938 14.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f55d0b",
    d: "M 15 11.792969 C 16.503906 11.792969 17.722656 10.574219 17.722656 9.074219 C 17.722656 7.570312 16.503906 6.351562 15 6.351562 C 13.5 6.351562 12.28125 7.570312 12.28125 9.074219 C 12.28125 10.574219 13.5 11.792969 15 11.792969 Z M 15 11.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55d0b",
    d: "M 15 0.90625 C 10.496094 0.90625 6.835938 4.570312 6.835938 9.074219 C 6.835938 13.574219 10.496094 17.238281 15 17.238281 C 19.503906 17.238281 23.164062 13.574219 23.164062 9.074219 C 23.164062 4.570312 19.503906 0.90625 15 0.90625 Z M 15 13.609375 C 14.101562 13.609375 13.226562 13.34375 12.480469 12.84375 C 11.734375 12.347656 11.152344 11.636719 10.808594 10.808594 C 10.464844 9.980469 10.375 9.066406 10.550781 8.1875 C 10.726562 7.308594 11.15625 6.5 11.792969 5.863281 C 12.425781 5.230469 13.234375 4.796875 14.113281 4.625 C 14.996094 4.449219 15.90625 4.539062 16.734375 4.882812 C 17.566406 5.226562 18.273438 5.804688 18.773438 6.550781 C 19.269531 7.296875 19.535156 8.175781 19.535156 9.074219 C 19.535156 10.273438 19.054688 11.429688 18.207031 12.277344 C 17.355469 13.128906 16.203125 13.609375 15 13.609375 Z M 15 13.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonOrange);
export default __webpack_public_path__ + "static/media/ribbon-orange.9c91398863345818c44d53b6ef3db089.svg";
export { ForwardRef as ReactComponent };